import { render } from "./system-preferences.vue?vue&type=template&id=0fcd0cfc&scoped=true"
import script from "./system-preferences.vue?vue&type=script&lang=js"
export * from "./system-preferences.vue?vue&type=script&lang=js"

import "./system-preferences.vue?vue&type=style&index=0&id=0fcd0cfc&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcd0cfc"]])

export default __exports__